import { render, staticRenderFns } from "./GenreModal.vue?vue&type=template&id=5318ed7f&scoped=true&"
import script from "./GenreModal.vue?vue&type=script&lang=js&"
export * from "./GenreModal.vue?vue&type=script&lang=js&"
import style0 from "./GenreModal.vue?vue&type=style&index=0&id=5318ed7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318ed7f",
  null
  
)

export default component.exports